import { OpenInNew } from '@mui/icons-material'
import { Alert, AlertTitle, Typography } from '@mui/material'

import { Link } from 'components/Link'
import FlexBox from '../FlexBox'
import { AlertBoxProps } from './types'

export const AlertBox = ({ children, title, url, ...props }: AlertBoxProps): React.JSX.Element => (
  <Alert
    {...props}
    data-cy={`alert-box-${props.severity}`}
  >
    <AlertTitle>
      <FlexBox
        axis='x'
        sx={{ justifyContent: 'space-between' }}
      >
        <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>

        {url && (
          <Link
            newTab
            to={url}
          >
            <OpenInNew
              data-cy='open-in-new-icon'
              fontSize='small'
              sx={theme => ({ color: theme.palette.info.main })}
            />
          </Link>
        )}
      </FlexBox>
    </AlertTitle>

    {children}
  </Alert>
)
